module.exports = __webpack_public_path__ + "img/2015-neues-haus.3cec7556.jpg";